module.exports = "/assets/e4f9d4911aa2854e2a0d4470be537c4a.png";